import { FieldValidationMessageComponent } from './field-validation-message/field-validation-message.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortablePlaceholderComponent } from './sortable-placeholder/sortable-placeholder.component';
import { AnalyticsButtonComponent } from './analytics-button/analytics-button.component';
import { AnalyticsLinkComponent } from './analytics-link/analytics-link.component';
import { RecomendedSectionStatusComponent } from './recomended-section/recomended-section.component';
import { OverlayTreeComponent } from './overlay-tree/overlay-tree.component';
import { FormsModule } from '@angular/forms';
import { CierantTooltipDirective } from './cierant-tooltip/cierant-tooltip.directive';
import { BsDatepickerModule, CarouselModule, ModalModule, ProgressbarModule } from 'ngx-bootstrap';
import { CierantCalendarComponent } from './cierant-calendar/calendar.component';
import { CierantTypeaheadComponent } from './cierant-typeahead/cierant-typeahead.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { AppDatatableModule } from '../../shared/datatable';
import { ToolTipImagePreviewModalComponent } from './image-previwer/image-preview.modal.component';
import { CierantSwiperComponent } from './cierant-swiper/cierant-swiper.component';
import { SwiperModule } from 'angular2-useful-swiper';
import { DirectivesModule } from '../directives';
import { NotifyButtonComponent } from './notify-button/notify-button.component';
import { CierantDropdownSearchableComponent } from './cierant-dropdown-searchable/cierant-dropdown-searchable.component';
import { CierantDynamicReportComponent } from './cierant-dynamic-report/cierant-dynamic-report.component';
import { ScrollTrackerDirective } from './ScrollTrackerDirective/ScrollTrackerDirective';
import { CierantCheckboxComponent } from './cierant-checkbox/cierant-checkbox.component';
import { CierantSearchableTableComponent } from './cierant-searchable-table/cierant-searchable-table.component';
import { JobsToBeDoneDetailsComponent } from './jobs-to-be-done-details/jobs-to-be-done-details.component';
import { HierarchyMultiselectComponent } from './hierarchy-multiselect/hierarchy-multiselect.component';
import { ProgramTopInfoComponent } from './program-top-info/program-top-info.component';
import { PipesModule } from '../pipes';
import { ExpenseManagementTabsComponent } from './expense-management-tabs/expense-management-tabs.component';
import { ExpandableTableComponent } from './expandable-table/expandable-table.component';
import { CommentItemComponent } from './comment-item/comment-item.component';
import { CommentsComponent } from './comments/comments.component';
import {NgbPaginationConfig, NgbPaginationModule} from '@ng-bootstrap/ng-bootstrap';
import { ChatMessageComponent } from './chat-message/chat-message.component';
import { DropzoneConfigInterface, DropzoneModule, DROPZONE_CONFIG } from 'ngx-dropzone-wrapper';
import { DeliveryInformationFinalizeComponent } from './delivery-information/delivery-information.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { CierantDynamicTableComponent } from './cierant-dynamic-table/cierant-dynamic-table.component';
import { MentionModule } from 'angular-mentions/mention';
import { AddressEditModalComponent } from './address-edit/address-edit.modal.component';
import { SmartadminValidationModule } from '../forms/validation/smartadmin-validation.module';
import { SelectsModule } from '../selects/selects.module';
import { AppTypeaheadModule } from '../typeahead';
import { ValidationModule } from 'app/validation';
import { AddressListModalComponent } from './address-list/address-list.modal.component';
import { SmartadminEditorsModule } from '../forms/editors/smartadmin-editors.module';
import { PrintModalComponent } from './print/create.modal.component';


const DEFAULT_DROPZONE_CONFIG: DropzoneConfigInterface = {
    // Change this to your upload POST address:
     url: 'https://httpbin.org/post',
     maxFilesize: 50,
     acceptedFiles: 'csv/*'
};
@NgModule({
    declarations: [
        FieldValidationMessageComponent,
        SortablePlaceholderComponent,
        AnalyticsButtonComponent,
        AnalyticsLinkComponent,
        RecomendedSectionStatusComponent,
        OverlayTreeComponent,
        CierantTooltipDirective,
        CierantCalendarComponent,
        CierantTypeaheadComponent,
        ToolTipImagePreviewModalComponent,
        CierantSwiperComponent,
        NotifyButtonComponent,
        CierantDropdownSearchableComponent,
        CierantDynamicReportComponent,
        ScrollTrackerDirective,
        CierantCheckboxComponent,
        CierantSearchableTableComponent,
        JobsToBeDoneDetailsComponent,
        HierarchyMultiselectComponent,
        ProgramTopInfoComponent,
        ExpenseManagementTabsComponent,
        ExpandableTableComponent,
        CommentItemComponent,
        CommentsComponent,
        ChatMessageComponent,
        DeliveryInformationFinalizeComponent,
        CierantDynamicTableComponent,
        AddressEditModalComponent,
        AddressListModalComponent,
        PrintModalComponent
    ],
    imports: [ // import Angular's modules
        CommonModule,
        FormsModule,
        NgxDatatableModule,
        AppDatatableModule,
        SwiperModule,
        DirectivesModule,
        PipesModule,
        NgbPaginationModule,
        DropzoneModule,
        PdfViewerModule,
        ModalModule.forRoot(),
        MentionModule,
        BsDatepickerModule.forRoot(),
        ProgressbarModule.forRoot(),
        SmartadminValidationModule,
        SelectsModule,
        AppTypeaheadModule,
        ValidationModule,
        SmartadminEditorsModule
    ],
    exports: [
        FieldValidationMessageComponent,
        SortablePlaceholderComponent,
        AnalyticsButtonComponent,
        AnalyticsLinkComponent,
        RecomendedSectionStatusComponent,
        OverlayTreeComponent,
        CierantTooltipDirective,
        CierantCalendarComponent,
        CierantTypeaheadComponent,
        ToolTipImagePreviewModalComponent,
        CierantSwiperComponent,
        NotifyButtonComponent,
        CierantDropdownSearchableComponent,
        CierantDynamicReportComponent,
        ScrollTrackerDirective,
        CierantCheckboxComponent,
        CierantSearchableTableComponent,
        JobsToBeDoneDetailsComponent,
        HierarchyMultiselectComponent,
        ProgramTopInfoComponent,
        ExpenseManagementTabsComponent,
        ExpandableTableComponent,
        ChatMessageComponent,
        DeliveryInformationFinalizeComponent,
        CierantDynamicTableComponent,
        AddressEditModalComponent,
        AddressListModalComponent,
        PrintModalComponent
    ],
    providers: [ // expose our Services and Providers into Angular's dependency injection
        NgbPaginationConfig,
        {
            provide: DROPZONE_CONFIG,
            useValue: DEFAULT_DROPZONE_CONFIG
        }
    ],
    entryComponents: [
        FieldValidationMessageComponent,
        ToolTipImagePreviewModalComponent,
        AddressEditModalComponent,
        AddressListModalComponent,
        PrintModalComponent
    ]
})
export class SharedComponentsModule {
    constructor() { }
}




// WEBPACK FOOTER //
// ./src/app/shared/components/shared-components.module.ts